import React, { useEffect, useState } from "react";
import SBox from '../../Basicos/LVSelectBoxConList';

function ComboAbmEexPersonasTipos({ onValueChanged, value, visible = true, ancho = "100%" }) {
  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || "");

  // Datos estáticos de tipos de persona
  const tiposPersona = [
    { IdTipoPersona: 10, Descripcion: "Mozo" },
    { IdTipoPersona: 20, Descripcion: "Cajero" },
    { IdTipoPersona: 30, Descripcion: "Encargado" },
    { IdTipoPersona: 40, Descripcion: "Gerente" },
    { IdTipoPersona: 50, Descripcion: "Técnico" }
  ];

  useEffect(() => {
    // Cargar datos estáticos al inicializar el componente
    setData(tiposPersona);

    // Si hay un valor inicial, seleccionarlo
    if (value) {
      setSelectedValue(value);
    }
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      // Si vino un valor desde afuera -> lo pongo
      if (value) {
        setSelectedValue(value);
      } 
      // Si no vino valor pero hay un solo registro -> lo pongo
      else if (data.length === 1) {
        setSelectedValue(data[0].IdTipoPersona);
        if (onValueChanged) {
          onValueChanged({ value: data[0].IdTipoPersona });
        }
      }
    }
  }, [data, value]);

  return (
    <SBox
      textoLabel=""
      textoSelectBox="Seleccionar Tipo de Persona"
      data={data}
      campoCodigo="IdTipoPersona"
      campoDescripcion="Descripcion"
      ancho={ancho}
      onValueChanged={(e) => {
        setSelectedValue(e.value);
        if (onValueChanged) onValueChanged(e);
      }}
      value={selectedValue}
      visible={visible}
    />
  );
}

export default ComboAbmEexPersonasTipos;
